import React, { useState } from "react";
import { Alert } from "antd";
import moment from "moment";

import { useMsal } from "@azure/msal-react";

import { loginRequest } from "../../authConfig";
import * as env from "../../enviroment";

export const LoginForm = () => {
  const { instance } = useMsal();
  const [isNotAllowed, setIsNotAllowed] = useState(false);

  const handleLogin = async (instance) => {
    localStorage.clear();
    const response = await instance.loginPopup(loginRequest);
    checkIfUserHasIntoResourceGroup(response.account);
  };

  const checkIfUserHasIntoResourceGroup = (account) => {
    const { idTokenClaims, username } = account;

    if (idTokenClaims && username) {
      const { groups } = idTokenClaims;

      if (!groups.includes(env.RESOURCE_GROUP_ID)) {
        console.log(
          "El usuario no pertenece al grupo: ",
          env.RESOURCE_GROUP_NAME
        );
        setIsNotAllowed(true);

        return;
      }

      localStorage.setItem("dbhuseread", JSON.stringify(account));

      let sessionTimeout = moment().add(240, "minutes");

      localStorage.setItem(
        "dbhsessioneadTimeout",
        sessionTimeout.format("DD/MM/YYYY, h:mm:ss a")
      );

      localStorage.setItem("dbhloggedead", true);

      window.location.reload();
    }
  };

  return (
    <div className="login-form">
      {isNotAllowed && (
        <div className="login-not-allowed">
          <Alert
            message={
              <p>
                No estás autorizado para acceder al módulo <em>Trazabilidad</em>. Solicita acceso a través de la mesa de ayuda indicando el grupo de seguridad {env.RESOURCE_GROUP_NAME}.
                <br/>
                <a href={process.env.REACT_APP_LANDING_REDIRECT}>Volver</a>
              </p>
            }
            type="error"
          />
        </div>
      )}
      {!isNotAllowed && (
        <div className="login-form__card">
          <label className="login-form__title">Iniciar sesión</label>
          <label className="login-form__info">
            Accede a la aplicación con tu cuenta corporativa de Haceb.
            
          </label>
          <button
            className="login-form__button"
            onClick={() => {
              handleLogin(instance);
            }}
          >
            Ingresar
          </button>
        </div>
      )}
    </div>
  );
};
